module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Salas-1.17dcc9d9.png";